import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from './Icon';
import './Star.sass';

function Star(props) {
  const {
    color, isDisabled, isActive, isActiveHalf, willBeActive,
  } = props;

  return (
    <>
      { color && (
        <style>
          {`\
            .react-rater-star.will-be-active svg polygon {
              fill: ${color}
            }
            .react-rater-star.is-active svg polygon {
              fill: ${color}
            }
            .react-rater-star.is-active-half:before svg polygon {
              fill: ${color}
            }
        `}
        </style>
      )}
      <div className={classNames('react-rater-star', {
        'is-disabled': isDisabled, 'is-active': isActive, 'is-active-half': isActiveHalf, 'will-be-active': willBeActive,
      })}
      >
        <Icon />
      </div>
    </>
  );
}

Star.propTypes = {
  isActive: PropTypes.bool,
  isActiveHalf: PropTypes.bool,
  willBeActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  color: PropTypes.string,
};

export default Star;
